<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Tipo Contato</mat-label>
      <mat-select formControlName="typeContact">
        @for (type of listType; track type) {
          <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-7/12"
      appearance="outline"
    >
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancel
    </button>
    @if (this.editItem.idCreate != undefined) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editContact()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createContact()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
